module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row offer-filter pad-top"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "track-by": "name",
      "multiple": true,
      "placeholder": _vm.$t('statistic.webmaster'),
      "label": "name",
      "disabled": _vm.disabled,
      "options": _vm.options,
      "taggable": true
    },
    on: {
      "tag": _vm.addTag
    },
    model: {
      value: (_vm.Storage.webAddTagFilter),
      callback: function($$v) {
        _vm.Storage.webAddTagFilter = $$v
      },
      expression: "Storage.webAddTagFilter"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f35c4a20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/filters/WebmasterFilter.vue
// module id = 602
// module chunks = 0